export const CHAT_EVENT = "chat";
export const SEEN_EVENT = "seen";

export const USER_LAST_SEEN = "userLastSeenAt";
export const ANONYMOUS_LAST_SEEN = "anonymLastSeenAt";

export const MESSAGE_LENGTH = 30000;
